function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#4A4A4A",
  strokeWidth: "1.473",
  d: "M4.236 9.191h31.527v21.8H4.236z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M2 7h4.5v4.364H2zm31.5 0H38v4.364h-4.5zm0 21.818H38v4.364h-4.5zm-31.5 0h4.5v4.364H2z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#4A4A4A",
  strokeWidth: "1.591"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M10.295 13.613h13.409v8.591H10.295z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.795 17.977h13.409v8.591H17.795z"
}))));